import { Box, Button, Grid, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { CustomPaper } from "../../../../../../../../components/CustomPaper"
import { ResendDailyCutsProps } from "./types"
import { ArrowBack } from "../../../../../../../../components/arrowBack"
import { LoadingButton } from "@mui/lab"
import { CustomTable } from "../../../../../../../../components"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { useState } from "react"


export const ResendDailyCuts = (props: ResendDailyCutsProps) => {

    const { t } = useTranslation()
    const styles = useStyles()

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description: string
        confirm: () => void
        cancel?: () => void
    }>({
        open: false,
        title: '',
        description: '',
        confirm: () => { }
    })

    const searchUsers = () => {

        if (props.usersSelected.length == 0) {
            props.searchButton.onClick()
        } else {
            setModal(prev => ({
                ...prev,
                open: true,
                title: t("general.userFilterWarningTitle"),
                description: t("general.userFilterWarningDescription"),
                cancel: closeModal,
                confirm: () => {
                    props.searchButton.onClick()
                    props.setUsersSelected([])
                    closeModal()
                }
            }))
        }
    }

    const closeModal = () => { setModal(prev => ({ ...prev, open: false })) }

    const handleSelects = (value: number[]) => {
        props.setUsersSelected(value)
    }


    return (
        <>
            <Grid container /* sx={{ height: '100%' }} */ spacing={3}>
                <Grid item xl={8} lg={8} md={12} sm={12} xs={12}>
                    <CustomPaper elevation={1} sx={styles.pd2}>
                        <Box sx={styles.containerBack}>
                            <ArrowBack
                                label={t("loogbook.titles.returnToTheListOfDailyCuts")}
                                arrowProps={{ sx: styles.back, onClick: () => { props.setStep(0) } }}
                            />
                        </Box>
                        <Box sx={styles.header}>
                            <Typography fontWeight={'bold'}>{t('loogbook.titles.resendDailyCuts')}</Typography>
                            <Box sx={styles.countAll}>
                                <Typography className="greyClass" fontWeight={'bold'}>{t('loogbook.titles.totalOfDailyCuts')}</Typography>
                                <Typography sx={styles.circle}>{ props.all ? props.totalCuts-props.cutsNoSelected.length:props.cutsSelected.length}</Typography>
                            </Box>
                        </Box>
                        <Box sx={styles.mhg}>
                            <CustomTable
                                loader={!!props.searchButton.loading}
                                name="Listado de cortes diarios"
                                dontRefresh
                                column={props.column}
                                row={props.row ?? []}
                                selected={-1}
                                tableChecks
                                onClick={(e) => { handleSelects(e.checks ?? []) }}
                                defaultChecks={props.usersSelected}
                            />
                        </Box>

                        <Box sx={styles.containerButton}>
                            <LoadingButton loading={!!props.submit} disabled={!props.usersSelected.length} variant="contained" onClick={()=>{props.handleSubmit()}}>{t('general.resend')}</LoadingButton>
                        </Box>
                    </CustomPaper>
                </Grid>
                <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
                    <CustomPaper elevation={1} sx={styles.pd2} >
                        <Box sx={styles.content}>
                            {props.rigthItem}
                        </Box>

                        <Box sx={styles.footerBtn}>
                            <Button onClick={props.cleanFilter} variant="text">{t('general.cleanFilters')}</Button>

                            <LoadingButton loading={!!props.searchButton.loading} disabled={props.searchButton.disabled} onClick={() => { searchUsers() }} variant='contained'>{t("general.searchUsers")}</LoadingButton>
                        </Box>
                    </CustomPaper>
                </Grid>
            </Grid>

            <SimpleModal
                open={modal.open}
                close={() => { closeModal() }}
                removeClose={!modal?.cancel}
                title={modal.title}
                description={modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                back={modal?.cancel ?? undefined}
                next={modal.confirm ?? closeModal}
            />

        </>
    )
}